import { StaticHeadersForm } from '@/components/form/StaticHeadersForm';
import type { ConfigureAuthStepProps } from '@/sections/seeds/components/modals/AddSeedByTypeModal/AddSeedByTypeModal.types';

export function ConfigureAuthStep({
  formData,
  setFormData,
}: ConfigureAuthStepProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <label className="flex cursor-pointer items-center gap-2">
          <input
            type="radio"
            name="authMode"
            checked={formData.authMode === 'skip'}
            onChange={() =>
              setFormData(prev => ({ ...prev, authMode: 'skip' }))
            }
            className="text-chariot-brand-primary focus:ring-chariot-brand-primary"
          />
          <span className="text-chariot-text-primary text-sm">
            Skip — scan without authentication
          </span>
        </label>
        <label className="flex cursor-pointer items-center gap-2">
          <input
            type="radio"
            name="authMode"
            checked={formData.authMode === 'static-headers'}
            onChange={() =>
              setFormData(prev => ({ ...prev, authMode: 'static-headers' }))
            }
            className="text-chariot-brand-primary focus:ring-chariot-brand-primary"
          />
          <span className="text-chariot-text-primary text-sm">
            Add static headers
          </span>
        </label>
      </div>

      {formData.authMode === 'static-headers' && (
        <div className="border-chariot-stroke rounded-lg border p-4">
          <StaticHeadersForm
            label={formData.authLabel}
            onLabelChange={authLabel =>
              setFormData(prev => ({ ...prev, authLabel }))
            }
            headers={formData.authHeaders}
            onHeadersChange={authHeaders =>
              setFormData(prev => ({ ...prev, authHeaders }))
            }
          />
        </div>
      )}
    </div>
  );
}
